var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBillUpload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "17px",
    viewBox: "0 0 14 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(1.000000, 1.000000)",
    stroke: "#0078D7",
    strokeWidth: 1.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.66666667,9.54545455 L6,6.81818182 L6,15 L1.33333333,15 C0.597333333,15 0,14.3890909 0,13.6363636 L0,4.09090909 L4,0 L10.6666667,0 C11.4026667,0 12,0.610909091 12,1.36363636 L12,13.6363636 C12,14.3890909 11.4026667,15 10.6666667,15 L8,15",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,0 L4,2.72727273 C4,3.48 3.40266667,4.09090909 2.66666667,4.09090909 L0,4.09090909",
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,6.81818182 L3.33333333,9.54545455",
    id: "Stroke-5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillUpload);
export default __webpack_public_path__ + "static/media/bill-upload.8bc1e5999db9b2883e58a513b85b8d1b.svg";
export { ForwardRef as ReactComponent };